var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.renderComponent,{tag:"component",attrs:{"item":_vm.item,"circuit":_vm.circuit,"parentItem":_vm.item}})}
var staticRenderFns = []

export { render, staticRenderFns }